// entities
import { CLUB_PLAN_ID, MAE_NUTRIDA_PLAN_ID, MENTORIA_PRIME_PLAN_ID, PLUS_PLAN_ID, PP_PLAN_ID } from '@/constants/hotmart-plans'
import { user_role, user_status } from '@/entities/user'

export function getUserStatusBadgeStyle(status: user_status): string {
  let badgeStyle = 'text-white text-xs '

  try {
    switch (status) {
      case user_status.ALLOWED:
        badgeStyle += 'bg-[#E2E4E7] !text-foreground'
        break
      case user_status.BLOCKED:
        badgeStyle += 'bg-red-500/25 !text-red-500'
        break
    }
  } catch (err) {
    console.error(`Unhandled error at utils/badges-util.getUserStatusBadgeStyle function. Details: ${err}`)
  } finally {
    return badgeStyle
  }
}
export function getUserRoleBadgeStyle(role: user_role): string {
  let badgeStyle = 'text-white text-xs '

  try {
    switch (role) {
      case user_role.ADMIN:
        badgeStyle += 'bg-blue-500'
        break
      case user_role.MODERATOR:
        badgeStyle += 'bg-primary'
        break
      case user_role.CUSTOMER:
        badgeStyle += 'bg-[#E2E4E7] !text-foreground'
        break
    }
  } catch (err) {
    console.error(`Unhandled error at utils/badges-util.getUserRoleBadgeStyle function. Details: ${err}`)
  } finally {
    return badgeStyle
  }
}

export function getUserPlanBadgeStyle(planId: number): string {
  let badgeStyle = 'text-white text-xs '

  try {
    switch (planId) {
      case PP_PLAN_ID: // PP
        badgeStyle += 'bg-blue-500'
        break
      case PLUS_PLAN_ID: // Plus
        badgeStyle += 'bg-primary'
        break
      case MENTORIA_PRIME_PLAN_ID: // Prime
        badgeStyle += 'bg-green-500'
        break
      case CLUB_PLAN_ID: // Club
        badgeStyle += 'bg-black'
        break
      case MAE_NUTRIDA_PLAN_ID: // Mae Nutrida
        badgeStyle += 'bg-gray-500'
        break
      default:
        badgeStyle += 'bg-red-500'
        break
    }
  } catch (err) {
    console.error(`Unhandled error at utils/badges-util.getUserPlanBadgeStyle function. Details: ${err}`)
  } finally {
    return badgeStyle
  }
}
